import { Observable } from 'rxjs';
import {
  CreateWalletSessionRequest,
  CreateWalletSessionResponse,
  GetWalletSessionResponse,
} from '../models/wallet-session.models';

export abstract class WalletSessionService {
  abstract createWalletSession(
    tenantId: string,
    request: CreateWalletSessionRequest,
  ): Observable<CreateWalletSessionResponse>;

  abstract getWalletSession(
    tenantId: string,
    wSessionId: string,
  ): Observable<GetWalletSessionResponse>;

  abstract completeWalletSession(
    tenantId: string,
    wSessionId: string,
  ): Observable<void>;
}
